import { Directive, OnInit, ElementRef, Output, EventEmitter, Renderer2, OnDestroy } from '@angular/core';
import { eventFindInPath } from '@fi-shared/utils';
import { FiBrowserEventsService } from '@fi-shared/fi-shared-services/fi-browser-events.service';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[fiToggleDropdown]',
    standalone: false,
})
export class ToggleDropdownDirective implements OnInit, OnDestroy {
    @Output() dropdownOpenedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    private readonly dropdownOpenClassName: string = 'open';
    private elementClickListener: () => void;
    private windowClickSubscription: Subscription;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private browserEventsService: FiBrowserEventsService,
    ) {}

    ngOnInit(): void {
        this.setElementClickListener();
    }

    private setElementClickListener(): void {
        this.elementClickListener = this.renderer.listen(this.elementRef.nativeElement, 'click', ($event: Event) => {
            if (!this.isToggleDropdownOffEvent($event)) this.toggleDropdown($event);
        });
    }

    private toggleDropdown(event: Event): void {
        this.elementRef.nativeElement.classList.contains(this.dropdownOpenClassName)
            ? this.checkClosePopup(event)
            : this.openDropdown();
    }

    public openDropdown(): void {
        this.renderer.addClass(this.elementRef.nativeElement, this.dropdownOpenClassName);
        setTimeout(() => {
            this.windowClickSubscription = this.browserEventsService
                .getWindowEventSubject$('click')
                .subscribe((event: Event) => this.checkClosePopup(event));
        });
        this.dropdownOpenedChange.emit(true);
    }

    public closeDropdown(): void {
        this.renderer.removeClass(this.elementRef.nativeElement, this.dropdownOpenClassName);
        if (this.windowClickSubscription) {
            this.windowClickSubscription.unsubscribe();
            this.windowClickSubscription = undefined;
        }
        this.dropdownOpenedChange.emit(false);
    }

    private checkClosePopup(event: Event): void {
        if (!this.isToggleDropdownOffEvent(event)) this.closeDropdown();
    }

    private isToggleDropdownOffEvent(event: Event): boolean {
        return !!eventFindInPath(event, '[ccm-toggle-dropdown-off]');
    }

    public ngOnDestroy(): void {
        this.elementClickListener();
    }
}
